import {getComplaintSummaries} from "../../service/JobComplaintService";

const cache = new Map();
const listeners = new Map();
const pendingIds = new Set();
let timer;

function publish(cosJobId, value) {
    cache.set(cosJobId, value);
    listeners.get(cosJobId)?.forEach(listener => listener(value));
}

async function flush() {
    timer = undefined;
    const ids = [...pendingIds];
    pendingIds.clear();
    if (!ids.length) return;
    try {
        const complained = new Set();
        for (let start = 0; start < ids.length; start += 1000) {
            const response = await getComplaintSummaries(ids.slice(start, start + 1000));
            if (!response.ok) throw new Error("Unable to load complaint summaries");
            (await response.json()).forEach(item => complained.add(item.cos_job_id));
        }
        ids.forEach(id => publish(id, complained.has(id)));
    } catch (error) {
        console.error(error);
    }
}

export function subscribeComplaintSummary(cosJobId, listener) {
    if (!listeners.has(cosJobId)) listeners.set(cosJobId, new Set());
    listeners.get(cosJobId).add(listener);
    if (cache.has(cosJobId)) {
        listener(cache.get(cosJobId));
    } else {
        pendingIds.add(cosJobId);
        if (!timer) timer = setTimeout(flush, 0);
    }
    return () => listeners.get(cosJobId)?.delete(listener);
}

export function markJobComplained(cosJobId) {
    publish(cosJobId, true);
}
